import "./styles.scss"

export const ButtonClose = ({ handleClick, type = 'primary' }) => {
  return (
    <button
      className={`button-close ${type}`}
      onClick={handleClick}
    >
      <i className="fi fi-sr-cross-circle"></i>
    </button>
  )
}